import { Tooltip } from '@mantine/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FunctionUnavailable = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('common')
  return (
    <Tooltip color="gray" label={t('functionUnavailable')}>
      {children}
    </Tooltip>
  )
}

export default FunctionUnavailable
